export default "__VITE_ASSET__364b11b8__"